import Options from './Options.esm.js';
import bruteforceMatcher from './matcher/bruteforce/feedback.esm.js';
import dateMatcher from './matcher/date/feedback.esm.js';
import dictionaryMatcher from './matcher/dictionary/feedback.esm.js';
import regexMatcher from './matcher/regex/feedback.esm.js';
import repeatMatcher from './matcher/repeat/feedback.esm.js';
import sequenceMatcher from './matcher/sequence/feedback.esm.js';
import spatialMatcher from './matcher/spatial/feedback.esm.js';

const defaultFeedback = {
  warning: '',
  suggestions: []
};
/*
 * -------------------------------------------------------------------------------
 *  Generate feedback ---------------------------------------------------------------
 * -------------------------------------------------------------------------------
 */

class Feedback {
  constructor() {
    this.matchers = {
      bruteforce: bruteforceMatcher,
      date: dateMatcher,
      dictionary: dictionaryMatcher,
      regex: regexMatcher,
      repeat: repeatMatcher,
      sequence: sequenceMatcher,
      spatial: spatialMatcher
    };
    this.defaultFeedback = {
      warning: '',
      suggestions: []
    };
    this.setDefaultSuggestions();
  }

  setDefaultSuggestions() {
    this.defaultFeedback.suggestions.push(Options.translations.suggestions.useWords, Options.translations.suggestions.noNeed);
  }

  getFeedback(score, sequence) {
    if (sequence.length === 0) {
      return this.defaultFeedback;
    }

    if (score > 2) {
      return defaultFeedback;
    }

    const extraFeedback = Options.translations.suggestions.anotherWord;
    const longestMatch = this.getLongestMatch(sequence);
    let feedback = this.getMatchFeedback(longestMatch, sequence.length === 1);

    if (feedback !== null && feedback !== undefined) {
      feedback.suggestions.unshift(extraFeedback);

      if (feedback.warning == null) {
        feedback.warning = '';
      }
    } else {
      feedback = {
        warning: '',
        suggestions: [extraFeedback]
      };
    }

    return feedback;
  }

  getLongestMatch(sequence) {
    let longestMatch = sequence[0];
    const slicedSequence = sequence.slice(1);
    slicedSequence.forEach(match => {
      if (match.token.length > longestMatch.token.length) {
        longestMatch = match;
      }
    });
    return longestMatch;
  }

  getMatchFeedback(match, isSoleMatch) {
    if (this.matchers[match.pattern]) {
      return this.matchers[match.pattern](match, isSoleMatch);
    }

    if (Options.matchers[match.pattern] && 'feedback' in Options.matchers[match.pattern]) {
      return Options.matchers[match.pattern].feedback(match, isSoleMatch);
    }

    return defaultFeedback;
  }

}

export { Feedback as default };
//# sourceMappingURL=Feedback.esm.js.map
